<div id="table-view-div" style="display: block">
  <div class="data-view-top">
    <div
      class="chose-layers-div"
      id="multi_placeholder"
      *ngIf="showParcel && verify2"
    >
      <p id="dataset">
        <span class="multi-layer-steps">{{ step1 }}</span
        ><b>Choose layers for which to download a PDF Table:</b>
      </p>
      <span style="display: block"
        ><div class="table_layers_name" style="display: inline-block">
          <input
            type="checkbox"
            #layerData
            id="layerData"
            [checked]="selectlayerData"
            (change)="layerDataType(layerData.checked)"
            class="table_view_checks"
            name="table_view_checks"
            value="+i+"
            style="position: absolute; left: 60px; margin-right: 5px"
          />
          <p class="layer_names">Parcels</p>
        </div>
        <div class="pdf_layers" style="display: inline-block">
          <input
            maxlength="100"
            class="table_layer"
            style="position: static; width: 125%"
            type="text"
            name="select-tool[]"
            id="PDF-title"
            placeholder="Title table here..."
            [(ngModel)]="title"
          /></div
      ></span>
    </div>
    <div
      class="chose-layers-div"
      id="multi_placeholder"
      *ngIf="!showParcel && !verify2"
    >
      <div>
        <span class="single-layer-steps">{{ step1 }}</span
        ><input
          type="text"
          name="select-tool[]"
          style="width: 70%; margin-top: 15px"
          id="PDF-title"
          placeholder="Title table here..."
          class="pdf-single_layer"
          [(ngModel)]="title"
        />
        <div id="" class="characters_limit" style="font-size: 12px">
          100 character limit
        </div>
      </div>
    </div>
    <div class="chose-settings-div">
      <p id="lable-settingss">
        <span
          class="multi-layer-steps single-layer-steps"
          style="display: inline"
          >{{ step2 }}</span
        ><b>Choose Settings:</b>
      </p>
      <span style="display: inline-block; margin-left: 45px"
        ><input
          type="checkbox"
          id="check-duplicates"
          [value]="true"
          [(ngModel)]="skipDuplicates"
        />&nbsp;</span
      >
      Skip duplicates &nbsp;<small id="tooltip-same" class="mytooltip"
        ><span class="tooltiptext tip-bottom" style="margin-left: -13px"
          >Where owner name and mailing address are the same for multiple
          parcels.</span
        >i</small
      >
    </div>
    <br />
  </div>
  <span style="display: inline-block; margin-left: 13px; margin-top: 13px"
    ><span
      class="multi-layer-steps single-layer-steps"
      style="display: inline"
      >{{ step3 }}</span
    >
    <a (click)="download()" id="submit-pdf" download>Download</a>
    <a id="submit-pdf1" hidden download>Download</a>

    <span
      *ngIf="showMsg === true"
      class="err-select-layers glyphicon glyphicon-warning-sign"
      style="margin-left: 5px; font-style: normal"
    ></span
    ><span *ngIf="showMsg === true" class="err-select-layers">
      To download, select one or more layers above</span
    ></span
  >
  <hr id="separater-line" />
  <div class="data-view-desc" id="fields-for-table">
    <p class="pdf_table_include">
      PDF tables will include the following fields:
    </p>
    <b>Selection ID</b><br /><b>APN</b><br /><b>Owner name</b><br /><b>
      Situs address</b
    ><br /><b> Mailing address</b><br />
    <p></p>
    <p>
      If you have selected multiple layers to download, each will generate a
      separate PDF file and will be downloaded automatically, appearing in your
      downloads folder.
    </p>
  </div>
</div>
<app-loader></app-loader>